import React from "react";

const SelectChatPage = () => {
  return (
    <div className="flex justify-center items-center bg-gray-50 m-auto">
      <div className="text-center p-6">
        {/* Message prompt */}
        <h1 className="text-3xl font-semibold text-gray-800 mb-6">
          Please select a chat
        </h1>

        {/* Chat Icon Placeholder */}
        <div className="flex justify-center">
          <div className="p-6 rounded-full bg-white shadow-lg text-5xl text-blue-500">
            {/* You can place an icon here if needed, but for now, it's empty */}
            &#128172; {/* Placeholder Chat Bubble Emoji */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectChatPage;
